/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { SearchFacet } from './SearchFacet';
import {
    SearchFacetFromJSON,
    SearchFacetFromJSONTyped,
    SearchFacetToJSON,
    SearchFacetToJSONTyped,
} from './SearchFacet';
import type { SolrOrganisationReduced } from './SolrOrganisationReduced';
import {
    SolrOrganisationReducedFromJSON,
    SolrOrganisationReducedFromJSONTyped,
    SolrOrganisationReducedToJSON,
    SolrOrganisationReducedToJSONTyped,
} from './SolrOrganisationReduced';

/**
 * 
 * @export
 * @interface SolrResultSolrOrganisationReduced
 */
export interface SolrResultSolrOrganisationReduced  {
    /**
     * 
     * @type {number}
     * @memberof SolrResultSolrOrganisationReduced
     */
    numberResults?: number;
    /**
     * 
     * @type {Array<SolrOrganisationReduced>}
     * @memberof SolrResultSolrOrganisationReduced
     */
    results?: Array<SolrOrganisationReduced>;
    /**
     * 
     * @type {Array<SearchFacet>}
     * @memberof SolrResultSolrOrganisationReduced
     */
    facets?: Array<SearchFacet>;
}

/**
 * Check if a given object implements the SolrResultSolrOrganisationReduced interface.
 */
export function instanceOfSolrResultSolrOrganisationReduced(value: object): value is SolrResultSolrOrganisationReduced {
    return true;
}

export function SolrResultSolrOrganisationReducedFromJSON(json: any): SolrResultSolrOrganisationReduced {
    return SolrResultSolrOrganisationReducedFromJSONTyped(json, false);
}

export function SolrResultSolrOrganisationReducedFromJSONTyped(json: any, ignoreDiscriminator: boolean): SolrResultSolrOrganisationReduced {
    if (json == null) {
        return json;
    }
    return {
        
                  'numberResults': json['numberResults'] == null ? undefined : json['numberResults'],
              'results': json['results'] == null ? undefined : ((json['results'] as Array<any>).map(SolrOrganisationReducedFromJSON)),
              'facets': json['facets'] == null ? undefined : ((json['facets'] as Array<any>).map(SearchFacetFromJSON)),
    };
}

export function SolrResultSolrOrganisationReducedToJSON(json: any): SolrResultSolrOrganisationReduced {
    return SolrResultSolrOrganisationReducedToJSONTyped(json, false);
}

export function SolrResultSolrOrganisationReducedToJSONTyped(value?: SolrResultSolrOrganisationReduced | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'numberResults': value['numberResults'],
        'results': value['results'] == null? value['results']: (value['results'] as Array<any>).map(SolrOrganisationReducedToJSON),
        'facets': value['facets'] == null? value['facets']: (value['facets'] as Array<any>).map(SearchFacetToJSON),
    };
}


